module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [(_vm.isEditing) ? _c('h2', [_vm._v("Redigér")]) : _c('h2', [_vm._v("Opret")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "input_title",
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder1
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Kode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder2
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', [(_vm.isEditing) ? _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--submit--loading': _vm.isDeleting
    },
    on: {
      "click": _vm.onClickDelete
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _vm._e()]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
        'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEditing ? 'Opdatér' : 'Opret') + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3383c5e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SchoolSettings/TableCreateModal.vue
// module id = 1579
// module chunks = 1